import {h, Fragment} from "preact"
export default function Checkbox({ value, selected,  count, onChange, className}) {
    return (
      <label
        className={`ns-checkbox ns-d-flex ns-justify-content-between ${className} ${
          selected ? "ns-checkbox-selected" : ""
        }`}
      >
        {value}
        <span>{count}</span>
        <input type="checkbox" checked={selected} onChange={onChange} />
        <span className="ns-checkmark" />
      </label>
    );
  }